import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import SwiperCore, {
  Navigation,
  Pagination,
  EffectFade,
  EffectCube,
  EffectCoverflow,
  Autoplay,
  Lazy,
  Virtual,
} from "swiper";
import {
  BigPlayButton,
  ControlBar,
  ForwardControl,
  PlaybackRateMenuButton,
  Player,
  ReplayControl,
} from "video-react";
import "@src/views/BackOffice/studio/cameras/VideoPlayerstyles/scss/video-react.scss";
import "@styles/react/libs/swiper/swiper.scss";
import "@styles/sass/5-pages/blog-details.scss";

SwiperCore.use([
  Navigation,
  Pagination,
  EffectFade,
  EffectCube,
  EffectCoverflow,
  Autoplay,
  Lazy,
  Virtual,
]);
const params = {
  spaceBetween: 30,
  centeredSlides: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  pagination: false,
};

const SwiperAutoplay = ({ data }) => {
  const photos = data?.Topic?.photos;
  const videos = data?.Topic?.video_file;
  const renderPhotos = () => {
    return photos?.map((item, i) => (
      <SwiperSlide key={i}>
        <img
          src={item.file && item.file}
          alt="swiper 1"
          style={{ borderRadius: "30px", height: "300px", width: "50%" }}
        />
      </SwiperSlide>
    ));
  };

  return (
    <div style={{ position: "sticky", textAlign: "center" }}>
      <div className="video_topic_by_id">
        {videos && (
          <Player
            fluid={false}
            aspectRatio="16:9"
            width="100%"
            height={350}
            src={videos}
            crossOrigin="anonymous"
          >
            <BigPlayButton position="center" />
            <ControlBar autoHide={false}>
              <PlaybackRateMenuButton rates={[5, 2, 1, 0.5, 0.1]} order={7} />
              <ReplayControl seconds={5} order={2.1} />
              <ForwardControl seconds={5} order={3.1} />
            </ControlBar>
          </Player>
        )}
      </div>

      <Swiper {...params}>{renderPhotos()}</Swiper>
    </div>
  );
};

export default SwiperAutoplay;
